import { render, staticRenderFns } from "./zhsz.vue?vue&type=template&id=5c48a370&scoped=true"
import script from "./zhsz.vue?vue&type=script&lang=js"
export * from "./zhsz.vue?vue&type=script&lang=js"
import style0 from "./zhsz.vue?vue&type=style&index=0&id=5c48a370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48a370",
  null
  
)

export default component.exports